import styled from "styled-components";

// Theme configurations
const themes = {
  dark: {
    textPrimary: "white",
    textSecondary: "rgba(255, 255, 255, 0.9)",
    textMuted: "rgba(255, 255, 255, 0.8)",
    textLight: "rgba(255, 255, 255, 0.5)",
    background: "rgba(255, 255, 255, 0.05)",
    backgroundStrong: "rgba(255, 255, 255, 0.03)",
    border: "rgba(255, 255, 255, 0.1)",
    borderDashed: "rgba(255, 255, 255, 0.3)",
    accent: "#2877D9",
    accentSecondary: "#1a1a2e",
    gradientBackground:
      "linear-gradient(135deg, rgba(77, 238, 234, 0.1), rgba(67, 233, 123, 0.1))",
    gradientBorder: "rgba(77, 238, 234, 0.3)",
  },
  light: {
    textPrimary: "#1a1a2e",
    textSecondary: "rgba(26, 26, 46, 0.9)",
    textMuted: "rgba(26, 26, 46, 0.8)",
    textLight: "rgba(26, 26, 46, 0.5)",
    background: "rgba(26, 26, 46, 0.03)",
    backgroundStrong: "rgba(26, 26, 46, 0.02)",
    border: "rgba(26, 26, 46, 0.1)",
    borderDashed: "rgba(26, 26, 46, 0.2)",
    accent: "#2877D9",
    accentSecondary: "#ffffff",
    gradientBackground:
      "linear-gradient(135deg, rgba(77, 238, 234, 0.08), rgba(67, 233, 123, 0.08))",
    gradientBorder: "rgba(77, 238, 234, 0.2)",
  },
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 64px;
`;

export const BackButton = styled.button`
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;

  display: inline-flex;
  align-items: center;
  margin-bottom: 4px;
  background: none;
  border: none;
  outline: none;
  width: fit-content;
  cursor: pointer;
  gap: 8px;
  letter-spacing: -0.075px;
  margin-top: 10px;
`;

export const Title = styled.h1`
  color: #fff;
  font-family: "Figtree";
  font-size: 26px;
  font-weight: 500;
  letter-spacing: -0.1px;
  margin-bottom: -40px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 17px;
  font-weight: 600;
  margin-top: ${(props) => (props.$marginTop ? "16px" : "0px")};
  letter-spacing: -0.085px;
`;

export const CorePrinciplesGrid = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 629px;
  gap: 12px;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 629px;
  gap: ${(props) => (props.$small ? "0px" : "12px")};
`;

export const PrincipleItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: ${(props) =>
    themes[props.theme]?.background || themes.dark.background};
  border-radius: 12px;
  border-left: 4px solid #2877d9;
  box-shadow: ${(props) =>
    props.theme === "light" ? "0 2px 8px rgba(0, 0, 0, 0.05)" : "none"};
`;

export const PrincipleNumber = styled.div`
  background: #2877d9;
  color: #1a1a2e;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
  margin-top: 2px;
`;

export const PrincipleText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px; /* 200% */
`;
export const PrincipleTextLight = styled.span`
  color: #d4d4d4;
  font-family: Figtree;
  font-size: 14.9px;
  font-weight: 400;
  line-height: 28px;
  margin-top: ${(props) => (props.$marginTop ? "10px" : "0px")};
`;

export const StepSection = styled.div`
  margin-bottom: 48px;
  border-radius: 16px;
  background: ${(props) =>
    themes[props.theme]?.backgroundStrong || themes.dark.backgroundStrong};
  padding: 32px;
  border: 1px solid
    ${(props) => themes[props.theme]?.border || themes.dark.border};
  box-shadow: ${(props) =>
    props.theme === "light" ? "0 4px 16px rgba(0, 0, 0, 0.05)" : "none"};
`;

export const StepNumber = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: #2877d9;
  margin-bottom: 8px;
`;

export const StepTitle = styled.h3`
  color: #fff;
  font-family: Figtree;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.1px;
  margin-bottom: 28px;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ImagePlaceholder = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const SubSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  > div {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  p {
    color: ${(props) =>
      themes[props.theme]?.textMuted || themes.dark.textMuted};
    font-size: 15px;
    line-height: 1.6;
    margin: 0;
  }
`;

export const SubSectionTitle = styled.h4`
  font-size: 20px;
  font-weight: 600;
  color: ${(props) =>
    themes[props.theme]?.textPrimary || themes.dark.textPrimary};
  margin-bottom: 16px;
`;

export const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BulletItem = styled.li`
  color: ${(props) => themes[props.theme]?.textMuted || themes.dark.textMuted};
  font-size: 15px;
  line-height: 1.6;
  position: relative;
  padding-left: 20px;

  &:before {
    content: "•";
    color: #2877d9;
    position: absolute;
    left: 0;
    font-weight: 700;
  }
`;

export const HighlightText = styled.h5`
  font-size: 16px;
  font-weight: 600;
  color: #2877d9;
  margin: 0;
`;

export const ReviewSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
`;

export const ReviewItem = styled.div`
  color: ${(props) => themes[props.theme]?.textMuted || themes.dark.textMuted};
  font-size: 15px;
  line-height: 1.6;
  position: relative;
  padding-left: 20px;

  &:before {
    content: "•";
    color: #2877d9;
    position: absolute;
    left: 0;
    font-weight: 700;
  }
`;

export const Summary = styled.div`
  text-align: center;
  padding: 32px;
  background: ${(props) =>
    themes[props.theme]?.gradientBackground || themes.dark.gradientBackground};
  border-radius: 16px;
  border: 1px solid
    ${(props) =>
      themes[props.theme]?.gradientBorder || themes.dark.gradientBorder};
  box-shadow: ${(props) =>
    props.theme === "light" ? "0 4px 16px rgba(0, 0, 0, 0.05)" : "none"};

  p {
    color: ${(props) =>
      themes[props.theme]?.textSecondary || themes.dark.textSecondary};
    font-size: 18px;
    font-weight: 500;
    margin: 0;
    font-style: italic;
  }
`;
